export enum ROLES {
    // Section cascade codes — appear in NEXUS_ROLES (FLOW) or KEY_CLOAK_ROLES_SUBS (all others) when the whole section is granted
    FLOW                = "ROLE_FLOW",
    CAIXA               = "ROLE_FLOW#CAIXA",
    PRE_VENDA           = "ROLE_FLOW#PRE_VENDA",
    VENDA               = "ROLE_FLOW#VENDA",
    ACOES_VENDA         = "ROLE_FLOW#VENDA#ACOES_VENDA",
    CONSIGNADO          = "ROLE_FLOW#CONSIGNADO",
    CADASTRO_PESSOA     = "ROLE_FLOW#CADASTRO_PESSOA",

    // Caixa — direct actions (KEY_CLOAK_ROLES_SUBS)
    CAIXA_ABERTURA      = "ROLE_FLOW#CAIXA#ABERTURA-DE-CAIXA",
    CAIXA_FECHAMENTO    = "ROLE_FLOW#CAIXA#FECHAMENTO-DE-CAIXA",

    // Caixa — outros movimentos leaf (NEXUS_ROLES)
    OUTROS_MOVIMENTOS   = "ROLE_FLOW#CAIXA#OUTROS_MOVIMENTOS",

    // Caixa — outros movimentos sub-actions (KEY_CLOAK_ROLES_SUBS)
    OUTROS_MOVIMENTOS_CANCELAR_VALE_PRESENTE = "ROLE_FLOW#CAIXA#OUTROS_MOVIMENTOS#CANCELAR-VALE-PRESENTE",
    OUTROS_MOVIMENTOS_REFORCAR               = "ROLE_FLOW#CAIXA#OUTROS_MOVIMENTOS#REFORCAR-CAIXA",
    OUTROS_MOVIMENTOS_SANGRAR                = "ROLE_FLOW#CAIXA#OUTROS_MOVIMENTOS#SANGRAR-CAIXA",
    OUTROS_MOVIMENTOS_TRANSFERIR             = "ROLE_FLOW#CAIXA#OUTROS_MOVIMENTOS#TRANSFERIR",

    // Pré-venda — novo leaf (NEXUS_ROLES)
    PRE_VENDA_NOVO               = "ROLE_FLOW#PRE_VENDA#NOVO",

    // Pré-venda — novo sub-actions (KEY_CLOAK_ROLES_SUBS)
    PRE_VENDA_NOVO_NOVO          = "ROLE_FLOW#PRE_VENDA#NOVO#NOVO-PRE-VENDA",
    PRE_VENDA_NOVO_DESCONTO_ITEM   = "ROLE_FLOW#PRE_VENDA#NOVO#DESCONTO-ITEM",
    PRE_VENDA_NOVO_DESCONTO_RODAPE = "ROLE_FLOW#PRE_VENDA#NOVO#DESCONTO-RODAPE",
    PRE_VENDA_NOVO_ACRESCIMO       = "ROLE_FLOW#PRE_VENDA#NOVO#ACRESCIMO",
    PRE_VENDA_NOVO_BRINDE          = "ROLE_FLOW#PRE_VENDA#NOVO#BRINDE",
    PRE_VENDA_NOVO_FINALIZAR        = "ROLE_FLOW#PRE_VENDA#NOVO#FINALIZAR-PRE-VENDA",
    PRE_VENDA_NOVO_OBSERVACAO       = "ROLE_FLOW#PRE_VENDA#NOVO#ADICIONAR-OBSERVACAO",
    PRE_VENDA_NOVO_CONSULTA_ESTOQUE = "ROLE_FLOW#PRE_VENDA#NOVO#CONSULTA-ESTOQUE",
    PRE_VENDA_NOVO_VALE_PRESENTE    = "ROLE_FLOW#PRE_VENDA#NOVO#VALE-PRESENTE",

    // Pré-venda — editar leaf (NEXUS_ROLES)
    PRE_VENDA_EDITAR             = "ROLE_FLOW#PRE_VENDA#EDITAR",

    // Pré-venda — editar sub-actions (KEY_CLOAK_ROLES_SUBS)
    PRE_VENDA_EDITAR_EDITAR           = "ROLE_FLOW#PRE_VENDA#EDITAR#EDITAR-PRE-VENDA",
    PRE_VENDA_EDITAR_FINALIZAR        = "ROLE_FLOW#PRE_VENDA#EDITAR#FINALIZAR-PRE-VENDA",
    PRE_VENDA_EDITAR_DESCONTO_ITEM    = "ROLE_FLOW#PRE_VENDA#EDITAR#DESCONTO-ITEM",
    PRE_VENDA_EDITAR_DESCONTO_RODAPE  = "ROLE_FLOW#PRE_VENDA#EDITAR#DESCONTO-RODAPE",
    PRE_VENDA_EDITAR_ACRESCIMO        = "ROLE_FLOW#PRE_VENDA#EDITAR#ACRESCIMO",
    PRE_VENDA_EDITAR_BRINDE           = "ROLE_FLOW#PRE_VENDA#EDITAR#BRINDE",
    PRE_VENDA_EDITAR_VALE_PRESENTE    = "ROLE_FLOW#PRE_VENDA#EDITAR#VALE-PRESENTE",
    PRE_VENDA_EDITAR_CONSULTA_ESTOQUE = "ROLE_FLOW#PRE_VENDA#EDITAR#CONSULTA-ESTOQUE",
    PRE_VENDA_EDITAR_OBSERVACAO       = "ROLE_FLOW#PRE_VENDA#EDITAR#ADICIONAR-OBSERVACAO",

    // Pré-venda — ações leaf + sub-action (KEY_CLOAK_ROLES_SUBS)
    PRE_VENDA_ACOES          = "ROLE_FLOW#PRE_VENDA#ACOES_PRE_VENDA",
    PRE_VENDA_ACOES_IMPRIMIR = "ROLE_FLOW#PRE_VENDA#ACOES_PRE_VENDA#IMPRIMIR-PRE-VENDA",

    // Vendas — direct actions (KEY_CLOAK_ROLES_SUBS)
    VENDA_SALVAR_PEDIDO    = "ROLE_FLOW#VENDA#SALVAR-PEDIDO",
    VENDA_FINALIZAR        = "ROLE_FLOW#VENDA#FINALIZAR-VENDA",
    VENDA_FINALIZAR_OUTROS = "ROLE_FLOW#VENDA#FINALIZAR-VENDA-OUTROS",

    // Vendas — leaf nodes (NEXUS_ROLES)
    VENDA_NOVO   = "ROLE_FLOW#VENDA#NOVO_VENDA",
    VENDA_EDITAR = "ROLE_FLOW#VENDA#EDITAR_VENDA",

    // Vendas — novo sub-actions (KEY_CLOAK_ROLES_SUBS)
    VENDA_NOVO_PEDIDO          = "ROLE_FLOW#VENDA#NOVO_VENDA#NOVO-PEDIDO",
    VENDA_NOVO_DESCONTO_ITEM   = "ROLE_FLOW#VENDA#NOVO_VENDA#DESCONTO-ITEM",
    VENDA_NOVO_DESCONTO_RODAPE = "ROLE_FLOW#VENDA#NOVO_VENDA#DESCONTO-RODAPE",
    VENDA_NOVO_ACRESCIMO       = "ROLE_FLOW#VENDA#NOVO_VENDA#ACRESCIMO",
    VENDA_NOVO_BRINDE          = "ROLE_FLOW#VENDA#NOVO_VENDA#BRINDE",
    VENDA_NOVO_DADOS_FRETE     = "ROLE_FLOW#VENDA#NOVO_VENDA#DADOS-FRETE",
    VENDA_NOVO_TROCA            = "ROLE_FLOW#VENDA#NOVO_VENDA#TROCA",
    VENDA_NOVO_VALE_PRESENTE    = "ROLE_FLOW#VENDA#NOVO_VENDA#VALE-PRESENTE",
    VENDA_NOVO_CONSULTA_ESTOQUE = "ROLE_FLOW#VENDA#NOVO_VENDA#CONSULTA-ESTOQUE",
    VENDA_NOVO_OBSERVACAO       = "ROLE_FLOW#VENDA#NOVO_VENDA#ADICIONAR-OBSERVACAO",

    // Vendas — editar sub-actions (KEY_CLOAK_ROLES_SUBS)
    VENDA_EDITAR_PEDIDO          = "ROLE_FLOW#VENDA#EDITAR_VENDA#EDITAR-PEDIDO",
    VENDA_EDITAR_DESCONTO_ITEM   = "ROLE_FLOW#VENDA#EDITAR_VENDA#DESCONTO-ITEM",
    VENDA_EDITAR_DESCONTO_RODAPE = "ROLE_FLOW#VENDA#EDITAR_VENDA#DESCONTO-RODAPE",
    VENDA_EDITAR_ACRESCIMO       = "ROLE_FLOW#VENDA#EDITAR_VENDA#ACRESCIMO",
    VENDA_EDITAR_BRINDE          = "ROLE_FLOW#VENDA#EDITAR_VENDA#BRINDE",
    VENDA_EDITAR_VENDEDOR        = "ROLE_FLOW#VENDA#EDITAR_VENDA#VENDEDOR",
    VENDA_EDITAR_DADOS_FRETE     = "ROLE_FLOW#VENDA#EDITAR_VENDA#DADOS-FRETE",
    VENDA_EDITAR_TROCA            = "ROLE_FLOW#VENDA#EDITAR_VENDA#TROCA",
    VENDA_EDITAR_VALE_PRESENTE    = "ROLE_FLOW#VENDA#EDITAR_VENDA#VALE-PRESENTE",
    VENDA_EDITAR_CONSULTA_ESTOQUE = "ROLE_FLOW#VENDA#EDITAR_VENDA#CONSULTA-ESTOQUE",
    VENDA_EDITAR_OBSERVACAO       = "ROLE_FLOW#VENDA#EDITAR_VENDA#ADICIONAR-OBSERVACAO",

    // Vendas — ações diretas (KEY_CLOAK_ROLES_SUBS)
    VENDA_ACOES_VISUALIZAR      = "ROLE_FLOW#VENDA#ACOES_VENDA#VISUALIZAR_VENDA",
    VENDA_ACOES_CONFERIR        = "ROLE_FLOW#VENDA#ACOES_VENDA#CONFERIR_VENDA",
    VENDA_ACOES_EDITAR_VENDEDOR = "ROLE_FLOW#VENDA#ACOES_VENDA#EDITAR_VENDEDOR",
    VENDA_ACOES_CANCELAR_PEDIDO = "ROLE_FLOW#VENDA#ACOES_VENDA#CANCELAR_PEDIDO",
    VENDA_ACOES_CANCELAR_DFE    = "ROLE_FLOW#VENDA#ACOES_VENDA#CANCELAR_DFE",
    VENDA_ACOES_AGRUPAR         = "ROLE_FLOW#VENDA#ACOES_VENDA#AGRUPAR_PEDIDO",
    VENDA_ACOES_BAIXAR_XML      = "ROLE_FLOW#VENDA#ACOES_VENDA#BAIXAR_XML",
    VENDA_ACOES_EXCLUIR_NOTA    = "ROLE_FLOW#VENDA#ACOES_VENDA#EXCLUIR_NOTA",
    VENDA_ACOES_ATUALIZAR_SITUACAO = "ROLE_FLOW#VENDA#ACOES_VENDA#ATUALIZAR_SITUACAO",

    // Vendas — imprimir leaf (NEXUS_ROLES)
    VENDA_ACOES_IMPRIMIR        = "ROLE_FLOW#VENDA#ACOES_VENDA#IMPRIMIR_VENDA",

    // Vendas — imprimir sub-actions (KEY_CLOAK_ROLES_SUBS)
    VENDA_ACOES_IMPRIMIR_PRE_VENDA            = "ROLE_FLOW#VENDA#ACOES_VENDA#IMPRIMIR_VENDA#PRE-VENDA",
    VENDA_ACOES_IMPRIMIR_PEDIDO               = "ROLE_FLOW#VENDA#ACOES_VENDA#IMPRIMIR_VENDA#PEDIDO",
    VENDA_ACOES_IMPRIMIR_DANFE                = "ROLE_FLOW#VENDA#ACOES_VENDA#IMPRIMIR_VENDA#DANFE",
    VENDA_ACOES_IMPRIMIR_ROMANEIO             = "ROLE_FLOW#VENDA#ACOES_VENDA#IMPRIMIR_VENDA#ROMANEIO",
    VENDA_ACOES_IMPRIMIR_ETIQUETA_VOLUME      = "ROLE_FLOW#VENDA#ACOES_VENDA#IMPRIMIR_VENDA#ETIQUETA-VOLUME",
    VENDA_ACOES_IMPRIMIR_CREDIARIO            = "ROLE_FLOW#VENDA#ACOES_VENDA#IMPRIMIR_VENDA#CREDIARIO",
    VENDA_ACOES_IMPRIMIR_ETIQUETA_SIMPLIFICADA = "ROLE_FLOW#VENDA#ACOES_VENDA#IMPRIMIR_VENDA#ETIQUETA-DFE-SIMPLIFICADA",

    // Consignado — direct action (KEY_CLOAK_ROLES_SUBS)
    CONSIGNADO_NOVO = "ROLE_FLOW#CONSIGNADO#NOVO",

    // Consignado — ações leaf (NEXUS_ROLES)
    CONSIGNADO_ACOES = "ROLE_FLOW#CONSIGNADO#ACOES_CONSIGNADO",

    // Consignado — ações sub-actions (KEY_CLOAK_ROLES_SUBS)
    CONSIGNADO_ACOES_IMPRIMIR      = "ROLE_FLOW#CONSIGNADO#ACOES_CONSIGNADO#IMPRIMIR",
    CONSIGNADO_ACOES_MOVIMENTACOES = "ROLE_FLOW#CONSIGNADO#ACOES_CONSIGNADO#MOVIMENTACOES",
    CONSIGNADO_ACOES_CANCELAR      = "ROLE_FLOW#CONSIGNADO#ACOES_CONSIGNADO#CANCELAR",
    CONSIGNADO_ACOES_DEVOLUCAO     = "ROLE_FLOW#CONSIGNADO#ACOES_CONSIGNADO#DEVOLUCAO",
    CONSIGNADO_ACOES_GERAR_VENDA   = "ROLE_FLOW#CONSIGNADO#ACOES_CONSIGNADO#GERAR-VENDA",
    CONSIGNADO_ACOES_FIXAR_DESCONTO = "ROLE_FLOW#CONSIGNADO#ACOES_CONSIGNADO#FIXAR-DESCONTO",
    CONSIGNADO_ACOES_OBSERVACAO     = "ROLE_FLOW#CONSIGNADO#ACOES_CONSIGNADO#ADICIONAR-OBSERVACAO",

    // Consignado — gerenciar leaf (NEXUS_ROLES)
    CONSIGNADO_GERENCIAR = "ROLE_FLOW#CONSIGNADO#GERENCIAR_CONSIGNADO",

    // Consignado — gerenciar sub-actions (KEY_CLOAK_ROLES_SUBS)
    CONSIGNADO_GERENCIAR_EDITAR           = "ROLE_FLOW#CONSIGNADO#GERENCIAR_CONSIGNADO#EDITAR-CONSIGNADO",
    CONSIGNADO_GERENCIAR_DESCONTO_ITEM    = "ROLE_FLOW#CONSIGNADO#GERENCIAR_CONSIGNADO#DESCONTO-ITEM",
    CONSIGNADO_GERENCIAR_CONSIGNAR        = "ROLE_FLOW#CONSIGNADO#GERENCIAR_CONSIGNADO#CONSIGNAR",
    CONSIGNADO_GERENCIAR_GERAR_VENDA      = "ROLE_FLOW#CONSIGNADO#GERENCIAR_CONSIGNADO#GERAR-VENDA",
    CONSIGNADO_GERENCIAR_DEVOLUCAO        = "ROLE_FLOW#CONSIGNADO#GERENCIAR_CONSIGNADO#DEVOLUCAO-CONSIGNADO",
    CONSIGNADO_GERENCIAR_CONSIGNAR_OUTROS = "ROLE_FLOW#CONSIGNADO#GERENCIAR_CONSIGNADO#CONSIGNAR-OUTROS",
    CONSIGNADO_GERENCIAR_FIXAR_DESCONTO   = "ROLE_FLOW#CONSIGNADO#GERENCIAR_CONSIGNADO#FIXAR-DESCONTO",
    CONSIGNADO_GERENCIAR_OBSERVACAO       = "ROLE_FLOW#CONSIGNADO#GERENCIAR_CONSIGNADO#ADICIONAR-OBSERVACAO",

    // Cadastro de pessoa — leaf nodes (NEXUS_ROLES)
    CADASTRO_PESSOA_NOVO   = "ROLE_FLOW#CADASTRO_PESSOA#NOVO_CADASTRO_PESSOA",
    CADASTRO_PESSOA_EDITAR = "ROLE_FLOW#CADASTRO_PESSOA#EDITAR_CADASTRO_PESSOA",

    // Cadastro de pessoa — novo sub-actions (KEY_CLOAK_ROLES_SUBS)
    CADASTRO_PESSOA_NOVO_PESSOA   = "ROLE_FLOW#CADASTRO_PESSOA#NOVO_CADASTRO_PESSOA#NOVO-PESSOA",
    CADASTRO_PESSOA_NOVO_PAPEL    = "ROLE_FLOW#CADASTRO_PESSOA#NOVO_CADASTRO_PESSOA#PAPEL",
    CADASTRO_PESSOA_NOVO_VENDEDOR = "ROLE_FLOW#CADASTRO_PESSOA#NOVO_CADASTRO_PESSOA#VENDEDOR",
    CADASTRO_PESSOA_NOVO_GUIA     = "ROLE_FLOW#CADASTRO_PESSOA#NOVO_CADASTRO_PESSOA#GUIA",

    // Cadastro de pessoa — editar sub-actions (KEY_CLOAK_ROLES_SUBS)
    CADASTRO_PESSOA_EDITAR_PESSOA   = "ROLE_FLOW#CADASTRO_PESSOA#EDITAR_CADASTRO_PESSOA#EDITAR-PESSOA",
    CADASTRO_PESSOA_EDITAR_PAPEL    = "ROLE_FLOW#CADASTRO_PESSOA#EDITAR_CADASTRO_PESSOA#PAPEL",
    CADASTRO_PESSOA_EDITAR_VENDEDOR = "ROLE_FLOW#CADASTRO_PESSOA#EDITAR_CADASTRO_PESSOA#VENDEDOR",
    CADASTRO_PESSOA_EDITAR_GUIA     = "ROLE_FLOW#CADASTRO_PESSOA#EDITAR_CADASTRO_PESSOA#GUIA",

    // Finanças
    // TODO: definir hierarquia de permissões para as ações de conta a receber
    CONTA_RECEBER               = "ROLE_CONTA_RECEBER",
    CONTA_RECEBER_BAIXAR        = "ROLE_CONTA_RECEBER#BAIXAR",
    CONTA_RECEBER_CONSULTAR     = "ROLE_CONTA_RECEBER#CONSULTAR",
    CONTA_RECEBER_EXCLUIR_BAIXA = "ROLE_CONTA_RECEBER#EXCLUIR-BAIXA",

    // System
    ADMIN = "ROLE_ADMIN",
    SUPER = "ROLE_SUPER",
}

export const ALL_FLOW_ROLES = [
    ROLES.FLOW,
    ROLES.CAIXA,
    ROLES.PRE_VENDA,
    ROLES.VENDA,
    ROLES.ACOES_VENDA,
    ROLES.CONSIGNADO,
    ROLES.CADASTRO_PESSOA,
    ROLES.OUTROS_MOVIMENTOS,
    ROLES.PRE_VENDA_NOVO,
    ROLES.PRE_VENDA_EDITAR,
    ROLES.PRE_VENDA_ACOES,
    ROLES.VENDA_NOVO,
    ROLES.VENDA_EDITAR,
    ROLES.VENDA_ACOES_VISUALIZAR,
    ROLES.VENDA_ACOES_CONFERIR,
    ROLES.VENDA_ACOES_EDITAR_VENDEDOR,
    ROLES.VENDA_ACOES_CANCELAR_PEDIDO,
    ROLES.VENDA_ACOES_CANCELAR_DFE,
    ROLES.VENDA_ACOES_AGRUPAR,
    ROLES.VENDA_ACOES_BAIXAR_XML,
    ROLES.VENDA_ACOES_EXCLUIR_NOTA,
    ROLES.VENDA_ACOES_ATUALIZAR_SITUACAO,
    ROLES.VENDA_ACOES_IMPRIMIR,
    ROLES.CONSIGNADO_ACOES,
    ROLES.CONSIGNADO_GERENCIAR,
    ROLES.CADASTRO_PESSOA_NOVO,
    ROLES.CADASTRO_PESSOA_EDITAR,
    ROLES.CONTA_RECEBER,
];
